import { User, roleValueIDs } from '../models/user';

// Ignore students
export const shouldShowBillingStatusIndicator = (user: User): boolean => {
  return user.info?.role !== roleValueIDs.student && !user?.isAnonymous;
};
